export default __webpack_public_path__ + "static/media/0009.7115b4f0.png";